// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import AView, {
    message
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import notification from 'ant-design-vue/es/notification'
// 引入全局cookie方法
import cookie from '../src/utils/cookie';
// 引入全局文件common.js
// import common from './common'
import common from '../common/common'
import session from '../common/session'
import storage from '../common/storage'
//全局css
import "./assets/less/common.less"
// 引入日期组件
import moment from 'moment'
// swiper轮播图组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper)

Vue.use(less)
    // mount axios to `Vue.$http` and `this.$http`
Vue.prototype.$moment = moment
Vue.prototype.$cookie = cookie
Vue.prototype.$common = common;
Vue.prototype.$session = session;
Vue.prototype.$storage = storage;

Vue.config.productionTip = false
    // 注册全局组件
Vue.use(AView);
message.config({
    top: 0,
    duration: 0.5,
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title + '-人才市场中心';
    }
    // 路由守卫，防止用户通过url跳转到不符合他权限的页面
    if (to.path === '/') {
        next();
    } else { // 每次页面跳转执行，apryPassport或adminPassport为空或过期，均提示跳转到首页
        let token = cookie.getCookie("apryPassport") === null || cookie.getCookie("apryPassport") === '' || cookie.getCookie("apryPassport") === undefined ? cookie.getCookie("adminPassport") : cookie.getCookie("apryPassport");
        if (token === null || token === '' || token === undefined) {
            notification.error({
                message: '登录状态过期，请重新登录'
            })
            setTimeout(function() {
                next('/');
            }, 1000)
        } else {
            next();
        }
    }
})


// WEBPACK FOOTER //
// ./src/main.js